import React, { useState } from 'react';

import Modal from 'components/Modal/Modal';

import s from './Faq.module.css';

export type TFaqNote = {
  id: number;
  title: string;
  text: string;
};

const FaqItem = ({ note }: { note: TFaqNote }) => {
  const [activeNoteId, setActiveNoteId] = useState<number | null>(null);

  const handleShowNote = () => {
    setActiveNoteId(note.id);
  };

  const handleHideNote = () => {
    setActiveNoteId(null);
  };

  return (
    <li>
      <button className={s.note} type="button" onClick={handleShowNote}>
        {note.title}
      </button>
      {note.id === activeNoteId && (
        <Modal title={note.title} className={s.modal} onClose={handleHideNote}>
          {note.text}
        </Modal>
      )}
    </li>
  );
};

const Faq = ({ notes }: { notes: TFaqNote[] }) => {
  if (notes.length === 0) {
    return null;
  }

  return (
    <ul className={s.notes}>
      {notes.map((note) => (
        <FaqItem note={note} key={note.id} />
      ))}
    </ul>
  );
};

export default Faq;
